import { j as e } from "./jsx-runtime-DmTjM30f.mjs";
import { useMemo as x, cloneElement as h } from "react";
import { c as d } from "./tw-cn-mXgPecoF.mjs";
import { D as b } from "./dot-badge-C98VgBNP.mjs";
import "./rectangle-button-Oc2I1olX.mjs";
import "./icon-button-DImUgRzQ.mjs";
import "./text-button-CzR6iE2X.mjs";
import "./floating-button-XxUwMo0R.mjs";
import "./page-indicator-PMs9GCzM.mjs";
import "./brand-logo-BUuWcWj4.mjs";
import "./toast-BSWyDdPV.mjs";
import "./client-COlxxEJZ.mjs";
import "./page-controller-yAty7RfK.mjs";
import "./thumbnail-8aXWo3oD.mjs";
import "./tab-B2ZEU_zN.mjs";
import { c as p } from "./index-BpNK5r1N.mjs";
import "./empty-state-DQmgkhGJ.mjs";
import "./bottom-navigation-CjCbgt66.mjs";
import "./top-navigation-BJizjYeR.mjs";
import "./divider-DmNXvsxd.mjs";
import "./message-box-NHwzGk-l.mjs";
import "./pc-dialog-sheet-CW44LAAI.mjs";
import "./chip-CuRVIAgM.mjs";
import "./accordion-lv5H0n3A.mjs";
import "./checkbox-OfaoZ-86.mjs";
import "./radio-button-2Msn3K2H.mjs";
import "./switch-DQfESaWj.mjs";
import "./tooltip-BDvG0_k5.mjs";
import "./bottom-sheet-C6vsCMV1.mjs";
import "./pulldown-trigger-B2Xvufnc.mjs";
import "./text-field-B-iyuBbQ.mjs";
import "./text-area-XkYJb4yk.mjs";
import "./day-picker-pagination-B7RqyC1K.mjs";
import "./stepper-BEIdxz-9.mjs";
import "./number-indicator-D6y1_icz.mjs";
import "react-dom";
const j = p(["inline-flex justify-center truncate"], {
  variants: {
    subTitle: {
      true: "flex flex-col h-68 justify-center",
      false: "items-center typography-subtitle-18-bold h-50"
    },
    isTransparent: {
      true: "bg-transparent text-static-white",
      false: "bg-static-white text-text-neutral-main"
    },
    isTransparentBg: {
      true: "bg-transparent"
    },
    icon: {
      true: "flex",
      false: ""
    },
    aside: {
      true: "gap-8 w-full",
      false: ""
    },
    showDotBadge: {
      true: "pr-6",
      false: ""
    }
  },
  defaultVariants: {
    subTitle: !1,
    isTransparent: !1,
    isTransparentBg: !1,
    icon: !1,
    aside: !1
  }
}), v = p(["typography-subtitle-16-bold relative flex max-w-[800px] items-center "]), y = ({
  title: s,
  subTitle: t = null,
  isTransparent: m = !1,
  isTransparentBg: r = !1,
  icon: a,
  aside: l,
  showDotBadge: i = !1,
  ...o
}) => {
  const c = j({
    subTitle: !!t,
    isTransparent: m,
    isTransparentBg: r,
    icon: !!a,
    aside: !!l,
    showDotBadge: i
  }), u = v(), n = x(() => a ? h(a, { className: "size-20" }) : null, [a]);
  return !s && !t && !n ? null : /* @__PURE__ */ e.jsxs("div", { className: c, ...o, children: [
    /* @__PURE__ */ e.jsxs("div", { className: u, children: [
      s,
      !!i && /* @__PURE__ */ e.jsx(b, {})
    ] }),
    (!!t || !!n) && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx("div", { className: "mt-2 flex max-w-[440px] truncate typography-body-13-regular", children: t }),
      n
    ] }),
    !!l && /* @__PURE__ */ e.jsx("div", { className: "ml-auto flex-none", children: l })
  ] });
};
y.displayName = "NDS.SubHeaderSmall";
const N = p(
  ["inline-flex pc:px-0 py-4 pc:items-center pc:typography-headline-24-bold text-text-neutral-main w-full"],
  {
    variants: {
      theme: {
        default: "bg-static-white",
        ghost: "bg-transparent",
        transparent: "bg-transparent !text-static-white"
      },
      subTitle: {
        true: "min-h-68 pc:min-h-80 ",
        false: "min-h-50 pc:min-h-80"
      },
      icon: {
        true: "flex",
        false: ""
      },
      aside: {
        true: "gap-8 pc:gap-16 w-full justify-between",
        false: ""
      }
    },
    defaultVariants: {
      theme: "default",
      subTitle: !1,
      icon: !1,
      aside: !1
    }
  }
), S = p(["relative pc:typography-headline-24-bold"], {
  variants: {
    mobileSize: {
      default: "typography-subtitle-18-bold",
      small: "typography-subtitle-16-bold"
    },
    showDotBadge: {
      true: "mr-6",
      false: ""
    }
  },
  defaultVariants: {
    mobileSize: "default",
    showDotBadge: !1
  }
}), g = ({
  title: s,
  subTitle: t = null,
  theme: m = "default",
  icon: r,
  aside: a,
  mobileSize: l = "default",
  showDotBadge: i = !1,
  className: o,
  ...c
}) => {
  const u = N({
    theme: m,
    subTitle: !!t,
    icon: !!r,
    aside: !!a
  }), n = S({ mobileSize: l, showDotBadge: i }), f = x(() => r ? h(r, { className: "size-20 pc:size-24" }) : null, [r]);
  return !s && !t && !f ? null : /* @__PURE__ */ e.jsxs("div", { className: d(u, o), ...c, children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex w-full flex-col justify-center pc:flex-row pc:items-center pc:justify-start", children: [
      /* @__PURE__ */ e.jsxs("div", { className: d("flex items-center", { "shrink-0 pc:max-w-[800px]": !!t }), children: [
        /* @__PURE__ */ e.jsxs("span", { className: n, children: [
          s,
          !!i && /* @__PURE__ */ e.jsx(b, {})
        ] }),
        f
      ] }),
      (!!t || !!f) && /* @__PURE__ */ e.jsx(
        "div",
        {
          className: d("mt-2 flex typography-body-13-regular pc:ml-20 pc:mt-0 pc:typography-subtitle-20-regular"),
          children: t
        }
      )
    ] }),
    !!a && /* @__PURE__ */ e.jsx("div", { className: "flex items-center", children: a })
  ] });
};
g.Small = y;
g.displayName = "NDS.SubHeader";
export {
  g as S
};
